import React from 'react';
import { ArrowUp } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-10 md:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_fbe0f837-d33d-4f84-bae0-21bace0d1680/artifacts/n9bb0eio_NEOPLIAGE%20sans%20fond.png" 
              alt="NEOPLIAGE" 
              className="h-16 mb-4"
            />
            <p className="text-gray-400 mb-2 text-sm">
              Marque de <strong>NEOMAT</strong>
            </p>
            <p className="text-gray-400 mb-4">
              Spécialiste du pliage aluminium pour le bâtiment
            </p>
          </div>

          {/* Products */}
          <div>
            <h3 className="font-bold text-white mb-4 text-lg">Produits</h3>
            <ul className="space-y-2">
              <li><a href="/produits" className="text-gray-400 hover:text-white transition-colors">Couvertines aluminium</a></li>
              <li><a href="/produits" className="text-gray-400 hover:text-white transition-colors">Couvertines acier</a></li>
              <li><a href="/produits" className="text-gray-400 hover:text-white transition-colors">Cornières</a></li>
              <li><a href="/devis" className="text-gray-400 hover:text-white transition-colors">Pliage sur mesure</a></li>
            </ul>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="font-bold text-white mb-4 text-lg">Navigation</h3>
            <ul className="space-y-2">
              <li><a href="/" className="text-gray-400 hover:text-white transition-colors">Accueil</a></li>
              <li><a href="/produits" className="text-gray-400 hover:text-white transition-colors">Produits</a></li>
              <li><a href="/devis" className="text-gray-400 hover:text-white transition-colors">Devis sur mesure</a></li>
              <li><a href="/contact" className="text-gray-400 hover:text-white transition-colors">Contact</a></li>
              <li><a href="/a-propos" className="text-gray-400 hover:text-white transition-colors">À propos</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-bold text-white mb-4 text-lg">Informations légales</h3>
            <ul className="space-y-2">
              <li><a href="/mentions-legales" className="text-gray-400 hover:text-white transition-colors">Mentions légales</a></li>
              <li><a href="/cgv" className="text-gray-400 hover:text-white transition-colors">CGV</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-white mb-4 text-lg">Contact</h3>
            <ul className="space-y-2 text-gray-400">
              <li className="font-semibold text-white">NEOPLIAGE</li>
              <li>📍 Siège : 23 Av. de la Libération</li>
              <li>📦 Retrait : 17 rue du Dépôt</li>
              <li>01500 Ambérieu-en-Bugey</li>
              <li className="pt-2">Tél : 06.37.06.03.16</li>
              <li>Email : contact@neopliage.fr</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2026 NEOPLIAGE - Une marque NEOMAT. Tous droits réservés. | Fabrication française</p>
        </div>
      </div>

      {/* Scroll to top button */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 bg-[#E42313] text-white p-3 rounded-full shadow-lg hover:bg-[#C11A0F] transition-all z-50"
        aria-label="Retour en haut"
      >
        <ArrowUp className="w-5 h-5" />
      </button>
    </footer>
  );
};

export default Footer;
